import { render, staticRenderFns } from "./PrivilegeCheckModal.vue?vue&type=template&id=1e463779&scoped=true"
import script from "./PrivilegeCheckModal.vue?vue&type=script&lang=js"
export * from "./PrivilegeCheckModal.vue?vue&type=script&lang=js"
import style0 from "./PrivilegeCheckModal.vue?vue&type=style&index=0&id=1e463779&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e463779",
  null
  
)

export default component.exports